import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Container, ModalBody, ModalFooter, Row } from 'reactstrap';
import { VCS_SLUG } from '../../../constants/api';
import { useLoggerContext } from '../../../contexts/LoggerContext';
import { RepositoryList } from './RepositoryList';
import { Search } from './Search';
const filterRepos = (optionList, search) => {
    const lcSearch = search.toLowerCase();
    return optionList.filter((option) => option.label.toLowerCase().indexOf(lcSearch) !== -1);
};
const findRepositoryById = (repositoryId, options) => {
    for (const repo of options) {
        if (repo.value === repositoryId) {
            return repo.label;
        }
    }
    throw new Error(`Repository ${repositoryId} not found.`);
};
export const Body = (props) => {
    const { options, defaultValues, user, onRegisterWebhook, onSubmit, } = props;
    const [search, setSearch] = useState('');
    const [values, setValues] = useState(defaultValues);
    const { t } = useTranslation();
    const logger = useLoggerContext();
    const selectedRepos = values.map((option) => option.value);
    const filteredOptions = filterRepos(options, search);
    // @ts-expect-error TS2345: Argument of type { label: string; value: string; }[] is not assignable to parameter of type
    const filteredValues = filterRepos(values, search);
    const reposWithHook = filteredOptions.filter((option) => option.registered);
    const reposWithoutHook = filteredOptions.filter((option) => !option.registered);
    const handleUpdateSearch = (event) => {
        setSearch(typeof event === 'object' ? event.target.value.substring(0, 20) : event);
    };
    const handleToggleItem = (label, value) => {
        logger.debug('Toggling single item', {
            label,
            value,
        });
        setValues(values.filter((option) => option.value === value).length !== 0
            ? values.filter((option) => option.value !== value)
            : [...values, { label, value }]);
    };
    const handleToggleItems = (items) => {
        logger.debug('Toggling items', {
            items,
        });
        const optionsByValue = Object.assign({}, ...options.map((option) => ({ [option.value]: option })));
        const selectedLabels = values.map((value) => value.value);
        const isSelectedAll = items.filter((item) => selectedLabels.includes(item)).length === items.length;
        setValues(isSelectedAll
            ? values.filter((value) => !items.includes(value.value))
            : [
                ...values,
                ...items
                    .filter((item) => !selectedLabels.includes(item))
                    .map((item) => ({
                    label: optionsByValue[item].label,
                    value: item,
                })),
            ]);
    };
    const handleToggleAll = () => {
        logger.debug('Toggling all');
        const filteredRepos = filterRepos(options, search);
        setValues((valueList) => {
            // @ts-expect-error TS2345: Argument of type 'Value[]' is not assignable to parameter of type 'Option[]'. Type 'Value' is missing the following properties from type 'Option': registered, registerable
            if (filterRepos(valueList, search).length < filteredRepos.length) {
                return filteredRepos.map((option) => ({
                    label: option.label,
                    value: option.value,
                }));
            }
            return [];
        });
    };
    const handleSubmit = () => {
        logger.debug('Submitting values', {
            values,
        });
        if (onSubmit) {
            // @ts-expect-error TS2345: Argument of type 'Value[]' is not assignable to parameter of type 'Option[]'. Type 'Value' is missing the following properties from type 'Option': registered, registerable
            onSubmit(values);
        }
    };
    const handleRegisterWebhook = async (repositoryId) => {
        logger.debug('registering webhook', {
            repositoryId,
        });
        try {
            const vcs = VCS_SLUG[user.vcs];
            const repositoryName = findRepositoryById(repositoryId, options);
            const owner = repositoryName.substring(0, repositoryName.indexOf('/'));
            const repository = repositoryName.substring(repositoryName.indexOf('/') + 1);
            if (onRegisterWebhook) {
                await onRegisterWebhook(vcs, owner, repository);
            }
            const isChecked = values.filter((value) => value.value === repositoryId).length > 0;
            if (!isChecked) {
                handleToggleItem(owner + '/' + repository, repositoryId);
            }
        }
        catch (exception) {
            logger.error('Webhook registration failed', {
                repositoryId,
                exception,
            });
        }
    };
    return _jsxs(_Fragment, { children: [_jsxs(ModalBody, { children: [_jsx(Search, { search: search, updateSearch: handleUpdateSearch }), _jsxs(Container, { fluid: true, className: 'repositories-modal__container', children: [_jsx(RepositoryList, { user: user, selectedRepos: selectedRepos, repos: reposWithHook, onToggleItem: handleToggleItem, onRegisterWebhook: handleRegisterWebhook, onToggleItems: handleToggleItems }), _jsx(RepositoryList, { user: user, selectedRepos: selectedRepos, repos: reposWithoutHook, onToggleItem: handleToggleItem, onRegisterWebhook: handleRegisterWebhook, onToggleItems: handleToggleItems }), filteredOptions.length > 0 ? null : _jsx(Row, { children: t('noRepositoryFound_plural') })] })] }), _jsxs(ModalFooter, { children: [filteredOptions.length === 0 ? null : (_jsx(Button, { color: 'secondary', onClick: handleToggleAll, "data-testid": "select-all-button", children: t(filteredValues.length < filteredOptions.length ? 'selectAll' : 'clearAll') })), _jsx(Button, { color: 'primary', onClick: handleSubmit, "data-testid": "submit-button", children: t('ok') })] })] });
};
